/* NYPH unified color search v3.1 - 2026-08-21
   ONE BOX, ALL BRANDS, with a brand pill on every row.

   WHY THE PILL MATTERS: color names collide across brands. "Swiss Coffee" is
   Benjamin Moore OC-45 AND three different Behr numbers AND a Valspar.
   "Alabaster" exists in four brands. Without the brand on the row the shopper
   picks the wrong one and the bench mixes a genuinely different color.

   ANTI-FLOOD: results are capped per brand and overall, so one generic query
   like "white" cannot bury the list. Benjamin Moore is always ranked first and
   gets a bigger allowance, because that is what we actually stock.

   PERF: Benjamin Moore loads immediately exactly as before, so page load is
   unchanged. The other seven books (~306KB) are fetched in the BACKGROUND on
   first focus, never on the critical path.

   SAFETY NET: free text is always captured, so a color in none of the books
   still reaches the order. */
(function () {
  var BM_URL = "https://cdn.shopify.com/s/files/1/0643/1365/5353/files/bm-colors-nohex.json?v=1755868630";
  var MAX_TOTAL = 18;      // never show more than this
  var MAX_PER_BRAND = 3;   // per non-BM brand
  var MAX_BM = 6;          // Benjamin Moore gets more room, it is what we stock

  function init() {
    var $box    = document.getElementById('bm-color-picker');
    var $input  = document.getElementById('bm-color-input');
    var $list   = document.getElementById('bm-results');
    var $wrap   = document.getElementById('bm-picked');
    var $chip   = document.getElementById('bm-chip');
    var $label  = document.getElementById('bm-label');
    var $hidden = document.getElementById('bm-hidden');
    var $hBrand = document.getElementById('bm-hidden-brand');
    var $hMatch = document.getElementById('bm-hidden-match');
    var $filter = document.getElementById('bm-brand-filter');
    var $hint   = document.getElementById('bm-hint');
    var $status = document.getElementById('bm-loading');
    if (!$input || !$hidden || !$box) return;
    if ($input.dataset.bmInit === '1') return;
    $input.dataset.bmInit = '1';

    var SOURCES = {};
    try { SOURCES = JSON.parse($box.getAttribute('data-color-sources') || '{}'); } catch (e) {}

    var ALL = [];
    var othersRequested = false;
    var open = false, hi = -1;

    var norm = function (s) { return (s || '').toString().trim().toLowerCase(); };

    var HINT_DEFAULT = '<span style="font-size:16px;line-height:1;">&#8595;</span> <span>Type any color from any brand. We mix it in Benjamin Moore paint.</span>';
    var HINT_SET     = '<span style="color:#0a8a3f;font-size:15px;line-height:1;">&#10003;</span> <span>Your color is set. Type here anytime to change it.</span>';
    function setHint(html) { if ($hint) $hint.innerHTML = html; }
    setHint(HINT_DEFAULT);

    function writeProps(colorLabel, brandName, isExactPick) {
      var isOther = brandName && brandName !== 'Benjamin Moore';
      $hidden.value = colorLabel || '';
      if ($hBrand) $hBrand.value = (isOther && colorLabel) ? brandName : '';
      if ($hMatch) $hMatch.value = (isOther && colorLabel) ? 'Color match, mixed in Benjamin Moore paint' : '';
      if ($label) $label.textContent = colorLabel ? (colorLabel + (isOther ? '  (' + brandName + ')' : '')) : '';
      if ($wrap)  $wrap.style.display = colorLabel ? 'flex' : 'none';
      setHint(colorLabel ? HINT_SET : HINT_DEFAULT);
      if (!isExactPick && $chip) $chip.style.background = '#fff';
    }

    function loadBM() {
      return fetch(BM_URL, { cache: 'force-cache' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!Array.isArray(data)) return;
          for (var i = 0; i < data.length; i++) {
            ALL.push({ code: data[i].code, name: data[i].name, swatch: data[i].swatch,
                       brandId: 'BM', brand: 'Benjamin Moore' });
          }
        })
        .catch(function () {});
    }

    function loadOthers() {
      if (othersRequested) return;
      othersRequested = true;
      if ($status) $status.textContent = 'Loading other brands...';
      var jobs = Object.keys(SOURCES).map(function (id) {
        return fetch(SOURCES[id], { cache: 'force-cache' })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (!d || !d.colors) return;
            for (var i = 0; i < d.colors.length; i++) {
              ALL.push({ code: d.colors[i][0], name: d.colors[i][1], brandId: id, brand: d.brandName || id });
            }
          })
          .catch(function () {});
      });
      Promise.all(jobs).then(function () {
        if ($status) $status.textContent = '';
        if ($input.value) render(itemsFor($input.value));
      });
    }

    function activeFilter() { return $filter ? $filter.value : 'ALL'; }

    // Rank: exact match, then name-prefix, then code-prefix, then contains.
    function scoreOf(c, q) {
      var name = norm(c.name), code = norm(c.code);
      if (name === q || code === q) return 0;
      if (name.indexOf(q) === 0) return 1;
      if (code.indexOf(q) === 0) return 2;
      if (name.indexOf(q) > -1) return 3;
      if (code.indexOf(q) > -1) return 4;
      return 99;
    }

    function itemsFor(raw) {
      var q = norm(raw);
      if (!q) return [];
      var f = activeFilter();
      var hits = [];
      for (var i = 0; i < ALL.length; i++) {
        var c = ALL[i];
        if (f !== 'ALL' && c.brandId !== f) continue;
        var s = scoreOf(c, q);
        if (s < 99) hits.push({ c: c, s: s });
      }
      hits.sort(function (a, b) {
        if (a.s !== b.s) return a.s - b.s;
        if (a.c.brandId === 'BM' && b.c.brandId !== 'BM') return -1;   // we stock BM
        if (b.c.brandId === 'BM' && a.c.brandId !== 'BM') return 1;
        return a.c.name.length - b.c.name.length;                      // shorter = closer
      });
      // cap per brand so one brand cannot flood the list
      var perBrand = {}, out = [];
      for (var k = 0; k < hits.length && out.length < MAX_TOTAL; k++) {
        var it = hits[k].c;
        var cap = (it.brandId === 'BM') ? MAX_BM : MAX_PER_BRAND;
        perBrand[it.brandId] = (perBrand[it.brandId] || 0) + 1;
        if (perBrand[it.brandId] > cap) continue;
        out.push(it);
      }
      out._more = hits.length - out.length;
      return out;
    }

    function labelFor(c) {
      return ((c.code || '') + ((c.code && c.name) ? ' ' : '') + (c.name || '')).trim();
    }

    var BADGE = { BM:'#16224a', SW:'#0b6b3a', BEHR:'#a2551f', FB:'#4a4a4a', PPG:'#1c5a86', VAL:'#7a3d8f', DE:'#8a1f3d', RAL:'#555' };

    function render(arr) {
      $list.innerHTML = '';
      if (!arr.length) { $list.style.display = 'none'; open = false; return; }
      arr.forEach(function (c, i) {
        var li = document.createElement('li');
        li.style.cssText = 'padding:9px 10px;cursor:pointer;display:flex;align-items:center;gap:10px;';
        if (c.swatch) {
          var sw = document.createElement('span');
          sw.style.cssText = "display:inline-block;width:16px;height:16px;border:1px solid #999;border-radius:4px;flex:0 0 auto;background:center/cover no-repeat url('" + c.swatch + "');";
          li.appendChild(sw);
        }
        var txt = document.createElement('span');
        txt.textContent = labelFor(c);
        txt.style.cssText = 'flex:1 1 auto;';
        li.appendChild(txt);
        var badge = document.createElement('span');
        badge.textContent = c.brand;
        badge.style.cssText = 'flex:0 0 auto;font-size:11px;font-weight:700;color:#fff;background:' + (BADGE[c.brandId] || '#666') + ';border-radius:999px;padding:2px 8px;white-space:nowrap;';
        li.appendChild(badge);
        li.addEventListener('mouseenter', function () { highlight(i); });
        li.addEventListener('mouseleave', function () { highlight(-1); });
        li.addEventListener('click', function () { choose(c); });
        $list.appendChild(li);
      });
      if (arr._more > 0) {
        var note = document.createElement('li');
        note.textContent = 'Keep typing to narrow ' + arr._more + ' more matches';
        note.style.cssText = 'padding:8px 10px;font-size:12px;color:#8893a8;background:#fafbfd;cursor:default;';
        $list.appendChild(note);
      }
      $list.style.display = 'block'; open = true; highlight(-1);
    }

    function highlight(i) {
      var kids = $list.children;
      for (var k = 0; k < kids.length; k++) {
        if (kids[k].textContent.indexOf('Keep typing') === 0) continue;
        kids[k].style.background = (k === i) ? '#f3f4f6' : '#fff';
      }
      hi = i;
    }

    function choose(c) {
      var label = labelFor(c);
      $input.value = label;
      if ($chip && c.swatch) $chip.style.background = "center/cover no-repeat url('" + c.swatch + "')";
      writeProps(label, c.brand, true);
      $list.style.display = 'none'; open = false;
    }

    $input.addEventListener('input', function (e) {
      loadOthers();
      writeProps(e.target.value.trim(), '', false);
      render(itemsFor(e.target.value));
    });
    $input.addEventListener('focus', loadOthers);

    if ($filter) $filter.addEventListener('change', function () { render(itemsFor($input.value)); });

    $input.addEventListener('keydown', function (e) {
      if (!open) return;
      var max = $list.children.length;
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(Math.min(max - 1, Math.max(0, hi + 1))); }
      if (e.key === 'ArrowUp')   { e.preventDefault(); highlight(Math.max(0, Math.min(max - 1, hi - 1))); }
      if (e.key === 'Enter')     { e.preventDefault(); if (hi >= 0 && $list.children[hi]) { $list.children[hi].click(); } else { $list.style.display = 'none'; open = false; } }
      if (e.key === 'Escape')    { $list.style.display = 'none'; open = false; }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('#bm-color-picker')) { $list.style.display = 'none'; open = false; }
    });

    function prefillFromURL() {
      try {
        var p = new URLSearchParams(location.search).get('color');
        if (!p) return;
        var q = norm(p);
        var m = ALL.filter(function (c) { return norm(c.code) === q; })[0]
             || ALL.filter(function (c) { return norm(labelFor(c)) === q; })[0]
             || ALL.filter(function (c) { return norm(c.name) === q; })[0];
        if (m) choose(m);
      } catch (e) {}
    }

    loadBM().then(prefillFromURL);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
